import { CommerceApiHttpService } from '../../common/types';
import { ProductExperienceApi } from '../../models/product/product.api';

export class FocProductExperienceApi implements ProductExperienceApi {
  constructor(private http: CommerceApiHttpService) {}

  public async getProduct(): Promise<any> {
    // const product = await this._http.get('/product/${id}');
    // const mappedProduct = mapProductToExperienceApi(product);
    // return mappedProduct;
    throw new Error('Not implemented');
  }
}
